import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC } from "react";
import { PsychologistFinancialValues } from "src/apis/psychologist";
import { formatCurrency } from "src/utils/currency";

type FinancialControlTableProps = {
  values?: PsychologistFinancialValues,
}

const FinancialControlTable: FC<FinancialControlTableProps> = ({ values }): JSX.Element => {
  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableCell colSpan={2}><strong>Remuneração total neste mês</strong></TableCell>
        </TableHead>

        <TableBody>
          <TableRow>
            <TableCell><strong>Atendimentos</strong></TableCell>
            <TableCell>{Boolean(values) ? formatCurrency(values?.montante_total_atendimentos) : 'N/A'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Ações</strong></TableCell>
            <TableCell>{Boolean(values) ? formatCurrency(values?.montante_total_acoes) : 'N/A'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell><strong>Total</strong></TableCell>
            <TableCell>{Boolean(values) ? formatCurrency(values?.montante_total) : 'N/A'}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default FinancialControlTable;
